import $ from 'jquery';
import Cookies from 'js-cookie'

export default function int_alert() {
	const isCookieEnabled = navigator.cookieEnabled;
	
	if($('.elements-alert').length){
		if(isCookieEnabled){
			if (!Cookies.get('dismissalert')){
				 $(".elements-alert").addClass('is-open');
			}
		}else{
			 $(".elements-alert").addClass('is-open');
		}
	}
	
    $('#alert-close').click(function () {
        $(".elements-alert").removeClass('is-open');
		
		if(isCookieEnabled){
			Cookies.set('dismissalert', true);
		}
		
    })
	
	if($('.elements-alert-banner').length){
		if(isCookieEnabled){
			if (!Cookies.get('dismissalertbanner')){
				 $(".elements-alert-banner").addClass('is-open');
			}
		}else{
			 $(".elements-alert-banner").addClass('is-open');
		}
	}
	
    $('#alert-banner-close').click(function () {
        $(".elements-alert-banner").removeClass('is-open');
		
		if(isCookieEnabled){
			Cookies.set('dismissalertbanner', true);
		}
		
    })
}

